<template>
  <div class="pt-5">
    <v-data-table
      :items="solicitudes"
      :headers="headers"
      :loading="loading"
      :server-items-length="totalItems"
      :items-per-page="pagination.itemsPerPage"
      :page="pagination.page"
      no-data-text="Sin solicitudes para mostrar"
      no-results-text="Sin resultados para mostrar"
      loading-text="Cargando..."
      :footer-props="{
        'items-per-page-all-text': 'Todos',
        'items-per-page-text': 'Elementos por página',
      }"
      @update:page="onPageChange"
      @update:items-per-page="onItemsPerPageChange"
    >
      <template v-slot:top>
        <v-row style="padding: 15px;">
          <v-col
            cols="12"
            :md="mostrarSeleccionMasiva ? 6 : 8"
          >
            <h2>Resultados de la búsqueda</h2>
          </v-col>

          <v-col
            v-if="mostrarSeleccionMasiva"
            cols="12"
            md="6"
            class="d-flex justify-end align-center"
          >
            <span
              v-if="haySeleccionParcial"
              class="mr-4 grey--text text--darken-1"
            >
              {{ textoSeleccion }}
            </span>

            <v-checkbox
              :input-value="seleccionarTodas"
              :indeterminate="haySeleccionParcial"
              label="Seleccionar todas"
              hide-details
              dense
              class="mt-0 pt-0"
              @change="onToggleSeleccionarTodas"
            />
          </v-col>
        </v-row>
      </template>

      <template
        v-if="mostrarSeleccionMasiva"
        v-slot:item.seleccionMasiva="{ item }"
      >
        <v-checkbox
          :input-value="estaSeleccionada(item.id)"
          hide-details
          dense
          class="mt-0 pt-0"
          @change="
            (seleccionado) =>
              onToggleSolicitud(item.id, seleccionado)
          "
        />
      </template>

      <template #item.ver="{ item }">
        <v-btn
          icon
          x-small
          @click="verSolicitud(item)"
        >
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>

      <template
        v-slot:footer.page-text="{
          pageStart,
          pageStop,
          itemsLength,
        }"
      >
        <div v-if="itemsLength">
          Mostrando {{ pageStart }} - {{ pageStop }} de
          {{ itemsLength }} solicitudes
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    solicitudes: Array,
    loading: Boolean,
    totalItems: Number,

    mostrarSeleccionMasiva: {
      type: Boolean,
      default: false,
    },

    seleccionarTodas: {
      type: Boolean,
      default: false,
    },

    idsIncluidos: {
      type: Array,
      default: () => [],
    },

    idsExcluidos: {
      type: Array,
      default: () => [],
    },

    pagination: {
      type: Object,
      required: true,
    },
  },

  computed: {
    headers() {
      const headers = [
        { text: "ID", value: "id" },
        { text: "Estatus", value: "statusTag" },
        {
          text: "Fecha Solicitud",
          value: "fechaCreacion",
        },
        { text: "Tipo", value: "tipo" },
        { text: "Categoría", value: "categoria" },
        { text: "Cliente", value: "nombre" },
        { text: "Operador", value: "nombreAgente" },
        {
          text: "Ver",
          value: "ver",
          sortable: false,
        },
      ];

      if (this.mostrarSeleccionMasiva) {
        headers.unshift({
          text: "",
          value: "seleccionMasiva",
          sortable: false,
          width: "50px",
        });
      }

      return headers;
    },

    haySeleccionParcial() {
      if (this.seleccionarTodas) {
        return this.idsExcluidos.length > 0;
      }

      return this.idsIncluidos.length > 0;
    },

    textoSeleccion() {
      if (this.seleccionarTodas) {
        if (this.idsExcluidos.length > 0) {
          return `Todas excepto ${this.idsExcluidos.length}`;
        }

        return "Todas seleccionadas";
      }

      return `${this.idsIncluidos.length} seleccionada(s)`;
    },
  },

  methods: {
    estaSeleccionada(id) {
      if (this.seleccionarTodas) {
        return !this.idsExcluidos.includes(id);
      }

      return this.idsIncluidos.includes(id);
    },

    onToggleSolicitud(id, seleccionado) {
      this.$emit(
        "toggle-seleccion-solicitud",
        {
          id,
          seleccionado,
        }
      );
    },

    onToggleSeleccionarTodas(seleccionar) {
      this.$emit(
        "toggle-seleccionar-todas",
        seleccionar
      );
    },

    verSolicitud(solicitud) {
      this.$router.push(
        `/solicitud/${solicitud.id}`
      );
    },

    onPageChange(newPage) {
      this.$emit(
        "update:pagination",
        {
          ...this.pagination,
          page: newPage,
        }
      );
    },

    onItemsPerPageChange(newSize) {
      this.$emit(
        "update:pagination",
        {
          ...this.pagination,
          itemsPerPage: newSize,
          page: 1,
        }
      );
    },
  },
};
</script>

<style scoped>
.theme--light.v-data-table {
  background-color: #fcf2f2;
  border-radius: 20px;
}
</style>
